import React from "react";
import { Modal, Button } from "@veneer/core";

interface CourseViewerModalProps {
  show: boolean;
  onClose: () => void;
  selectedCourseTab: number;
  actualCourse: any;
  buttonStartEvaluation: boolean;
  onOpenModalCertificate: (courseID: number) => void;
  onValidateStartEvaluation: (courseID: number) => void;
  sanitizeUrl: (url: string) => string;
  decryptText: (text: string) => string;
  t: (key: string) => string;
}

export const CourseViewerModal: React.FC<CourseViewerModalProps> = ({
  show,
  onClose,
  selectedCourseTab,
  actualCourse,
  buttonStartEvaluation,
  onOpenModalCertificate,
  onValidateStartEvaluation,
  sanitizeUrl,
  decryptText,
  t,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <Modal
        className="modalCourseAvailable"
        closeButton={true}
        align="center"
        id="modalCourseAvailable"
        show={show}
        onClose={onClose}
        title={actualCourse?.courseName}
      >
        <div className="modalCourseAvailableDiv">
          <iframe
            title={actualCourse?.courseName}
            src={sanitizeUrl(decryptText(actualCourse?.url))}
            className="modalCourseAvailableIFrame"
          />

          {selectedCourseTab === 2 ? (
            <Button
              onClick={() => onOpenModalCertificate(actualCourse?.courseID)}
            >
              {t("header.certificate")}
            </Button>
          ) : (
            <Button
              disabled={buttonStartEvaluation}
              onClick={() => onValidateStartEvaluation(actualCourse?.courseID)}
            >
              {t("header.startEvaluation")}
            </Button>
          )}
        </div>
      </Modal>
    </div>
  );
};
